import React from 'react';
// import { authRoles } from '../../auth/authRoles';

//navigations.jsで使用
const homeRoutes = [
	{
		path: '/shoplist', //URL
		component: React.lazy(() => import('./ShopList')),
	},

	{
		path: '/home', //URL
		component: React.lazy(() => import('./Home')), //遅延ロード用のコンポーネントをimportする
	},
	{
		path: '/shop/search',
		component: React.lazy(() => import('./Shop')),
	},
	{
		path: '/shop/result',
		component: React.lazy(() => import('./ShopResult')),
	},
	{
		path: '/sales/search',
		component: React.lazy(() => import('./Sales/Sales')),
	},
	{
		path: '/sales/result',
		component: React.lazy(() => import('./SalesResult')),
	},
	{
		path: '/cash',
		component: React.lazy(() => import('./Cash/Cash')),
	},
	{
		path: '/ir',
		component: React.lazy(() => import('./Ir')),
	},
	{
		path: '/salesterm',
		component: React.lazy(() => import('./SalesTerm/SalesTerm')),
	},
	{
		path: '/salestimezone',
		component: React.lazy(() => import('./SalesTimezone/SalesTimezone')),
	},
	{
		path: '/salescategory',
		component: React.lazy(() => import('./SalesCategory/SalesCategory')),
	},
	{
		path: '/salesitems',
		component: React.lazy(() => import('./SalesItems/SalesItems')),
	},
	{
		path: '/countproductoverview',
		component: React.lazy(() => import('./CountProductOverview/CountProductOverview')),
	},
	{
		path: '/countproductoverviewdetail',
		component: React.lazy(() => import('./CountProductOverview/CountProductOverviewDetail')),
	},
	{
		path: '/countproductoverviewdailydetail',
		component: React.lazy(() => import('./CountProductOverview/CountProductOverviewDailyDetail')),
	},
	{
		path: '/salesdaily',
		component: React.lazy(() => import('./SalesDaily/SalesDaily')),
	},
	{
		path: '/storehome',
		component: React.lazy(() => import('./StoreHome/StoreHome')),
	},

	{
		path: '/brandlist',
		component: React.lazy(() => import('./BrandList/BrandList')),
	},

	{
		path: '/createbrand',
		component: React.lazy(() => import('./CreateBrand/CreateBrand')),
	},
	{
		path: '/updatebrand',
		component: React.lazy(() => import('./UpdateBrand/UpdateBrand')),
	},
	{
		path: '/deletebrand',
		component: React.lazy(() => import('./DeleteBrand/DeleteBrand')),
	},

	{
		path: '/storeregist',
		component: React.lazy(() => import('./StoreRegist/StoreRegist')),
	},
	{
		path: '/storeedit',
		component: React.lazy(() => import('./StoreEdit/StoreEdit')),
	},
	{
		path: '/storeeditregist',
		component: React.lazy(() => import('./StoreEdit/StoreEditRegist')),
	},

	{
		path: '/storedelete',
		component: React.lazy(() => import('./StoreEdit/StoreDelete')),
	},
	{
		path: '/storebusinesshours',
		component: React.lazy(() => import('./StoreBusinessHours/StoreBusinessHours')),
	},
	{
		path: '/tradinghistory',
		component: React.lazy(() => import('./TradingHistory/TradingHistory')),
	},
	{
		path: '/tradingdaily',
		component: React.lazy(() => import('./TradingDaily/TradingDaily')),
	},
	{
		path: '/dailyclosing',
		component: React.lazy(() => import('./DailyClosing/DailyClosing')),
	},
	{
		path: '/dailydetail',
		component: React.lazy(() => import('./DailyDetail/DailyDetail')),
	},
	{
		path: '/dailydetailmonth',
		component: React.lazy(() => import('./DailyDetailMonth/DailyDetailMonth')),
	},
	{
		path: '/voidlist',
		component: React.lazy(() => import('./VoidList/VoidList')),
	},
	{
		path: '/dailymenugenerator',
		component: React.lazy(() => import('./DailyMenuGenerator/DailyMenuGenerator')),
	},

	{
		path: '/voiddaily',
		component: React.lazy(() => import('./VoidDaily/VoidDaily')),
	},

	{
		path: '/categoryeatin',
		component: React.lazy(() => import('./CategoryEatIn/CategoryEatIn')),
	},
	{
		path: '/categoryeatinregister',
		component: React.lazy(() => import('./CategoryEatIn/CategoryEatInRegister')),
	},
	{
		path: '/categoryeatincsvregister',
		component: React.lazy(() => import('./CategoryEatIn/CategoryEatInCsvRegister')),
	},
	{
		path: '/categoryeatinupdate',
		component: React.lazy(() => import('./CategoryEatIn/CategoryEatInUpdate')),
	},
	{
		path: '/categoryeatindelete',
		component: React.lazy(() => import('./CategoryEatIn/CategoryEatInDelete')),
	},


	{
		path: '/toppingeatin',
		component: React.lazy(() => import('./ToppingEatIn/ToppingEatIn')),
	},
	{
		path: '/toppingeatinregister',
		component: React.lazy(() => import('./ToppingEatIn/ToppingEatInRegister')),
	},
	{
		path: '/toppingeatincsvregister',
		component: React.lazy(() => import('./ToppingEatIn/ToppingEatInCsvRegister')),
	},
	{
		path: '/toppingeatinupdate',
		component: React.lazy(() => import('./ToppingEatIn/ToppingEatInUpdate')),
	},
	{
		path: '/toppingeatindelete',
		component: React.lazy(() => import('./ToppingEatIn/ToppingEatInDelete')),
	},


	{
		path: '/mcategoryeatin',
		component: React.lazy(() => import('./MenuCategoryEatIn/MenuCategoryEatIn')),
	},
	{
		path: '/mcategoryeatinregister',
		component: React.lazy(() => import('./MenuCategoryEatIn/MenuCategoryEatInRegister')),
	},
	{
		path: '/mcategoryeatincsvregister',
		component: React.lazy(() => import('./MenuCategoryEatIn/MenuCategoryEatInCsvRegister')),
	},
	{
		path: '/mcategoryeatinupdate',
		component: React.lazy(() => import('./MenuCategoryEatIn/MenuCategoryEatInUpdate')),
	},
	{
		path: '/mcategoryeatindelete',
		component: React.lazy(() => import('./MenuCategoryEatIn/MenuCategoryEatInDelete')),
	},


	{
		path: '/producteatin',
		component: React.lazy(() => import('./ProductEatIn/ProductEatIn')),
	},
	{
		path: '/producteatinregister',
		component: React.lazy(() => import('./ProductEatIn/ProductEatInRegister')),
	},
	{
		path: '/producteatincsvregister',
		component: React.lazy(() => import('./ProductEatIn/ProductEatInCsvRegister')),
	},
	{
		path: '/producteatinupdate',
		component: React.lazy(() => import('./ProductEatIn/ProductEatInUpdate')),
	},
	{
		path: '/producteatindelete',
		component: React.lazy(() => import('./ProductEatIn/ProductEatInDelete')),
	},
	{
		path: '/producteatininbound',
		component: React.lazy(() => import('./ProductEatIn/ProductEatInInbound')),
	},


	// ================================================================
	// 全店舗共通（storeId = 9999 固定）のイートイン商品メンテナンス
	// 店舗未選択（/storehome で選択解除）時のみサイドバーに表示される
	// ================================================================
	{
		path: '/categoryeatinall',
		component: React.lazy(() => import('./CategoryEatInAll/CategoryEatInAll')),
	},
	{
		path: '/categoryeatinallregister',
		component: React.lazy(() => import('./CategoryEatInAll/CategoryEatInAllRegister')),
	},
	{
		path: '/categoryeatinallcsvregister',
		component: React.lazy(() => import('./CategoryEatInAll/CategoryEatInAllCsvRegister')),
	},
	{
		path: '/categoryeatinallupdate',
		component: React.lazy(() => import('./CategoryEatInAll/CategoryEatInAllUpdate')),
	},
	{
		path: '/categoryeatinalldelete',
		component: React.lazy(() => import('./CategoryEatInAll/CategoryEatInAllDelete')),
	},


	{
		path: '/toppingeatinall',
		component: React.lazy(() => import('./ToppingEatInAll/ToppingEatInAll')),
	},
	{
		path: '/toppingeatinallregister',
		component: React.lazy(() => import('./ToppingEatInAll/ToppingEatInAllRegister')),
	},
	{
		path: '/toppingeatinallcsvregister',
		component: React.lazy(() => import('./ToppingEatInAll/ToppingEatInAllCsvRegister')),
	},
	{
		path: '/toppingeatinallupdate',
		component: React.lazy(() => import('./ToppingEatInAll/ToppingEatInAllUpdate')),
	},
	{
		path: '/toppingeatinalldelete',
		component: React.lazy(() => import('./ToppingEatInAll/ToppingEatInAllDelete')),
	},


	{
		path: '/producteatinall',
		component: React.lazy(() => import('./ProductEatInAll/ProductEatInAll')),
	},
	{
		path: '/producteatinallregister',
		component: React.lazy(() => import('./ProductEatInAll/ProductEatInAllRegister')),
	},
	{
		path: '/producteatinallcsvregister',
		component: React.lazy(() => import('./ProductEatInAll/ProductEatInAllCsvRegister')),
	},
	{
		path: '/producteatinallupdate',
		component: React.lazy(() => import('./ProductEatInAll/ProductEatInAllUpdate')),
	},
	{
		path: '/producteatinalldelete',
		component: React.lazy(() => import('./ProductEatInAll/ProductEatInAllDelete')),
	},
	{
		path: '/producteatinallinbound',
		component: React.lazy(() => import('./ProductEatInAll/ProductEatInAllInbound')),
	},



	{
		path: '/categorytakeout',
		component: React.lazy(() => import('./CategoryTakeOut/CategoryTakeOut')),
	},
	{
		path: '/categorytakeoutregister',
		component: React.lazy(() => import('./CategoryTakeOut/CategoryTakeOutRegister')),
	},
	{
		path: '/categorytakeoutcsvregister',
		component: React.lazy(() => import('./CategoryTakeOut/CategoryTakeOutCsvRegister')),
	},
	{
		path: '/categorytakeoutupdate',
		component: React.lazy(() => import('./CategoryTakeOut/CategoryTakeOutUpdate')),
	},
	{
		path: '/categorytakeoutdelete',
		component: React.lazy(() => import('./CategoryTakeOut/CategoryTakeOutDelete')),
	},


	{
		path: '/toppingtakeout',
		component: React.lazy(() => import('./ToppingTakeOut/ToppingTakeOut')),
	},
	{
		path: '/toppingtakeoutregister',
		component: React.lazy(() => import('./ToppingTakeOut/ToppingTakeOutRegister')),
	},
	{
		path: '/toppingtakeoutcsvregister',
		component: React.lazy(() => import('./ToppingTakeOut/ToppingTakeOutCsvRegister')),
	},
	{
		path: '/toppingtakeoutupdate',
		component: React.lazy(() => import('./ToppingTakeOut/ToppingTakeOutUpdate')),
	},
	{
		path: '/toppingtakeoutdelete',
		component: React.lazy(() => import('./ToppingTakeOut/ToppingTakeOutDelete')),
	},

	{
		path: '/producttakeout',
		component: React.lazy(() => import('./ProductTakeOut/ProductTakeOut')),
	},
	{
		path: '/producttakeoutregister',
		component: React.lazy(() => import('./ProductTakeOut/ProductTakeOutRegister')),
	},
	{
		path: '/producttakeoutcsvregister',
		component: React.lazy(() => import('./ProductTakeOut/ProductTakeOutCsvRegister')),
	},
	{
		path: '/producttakeoutupdate',
		component: React.lazy(() => import('./ProductTakeOut/ProductTakeOutUpdate')),
	},
	{
		path: '/producttakeoutdelete',
		component: React.lazy(() => import('./ProductTakeOut/ProductTakeOutDelete')),
	},


	{
		path: '/categorydelivery',
		component: React.lazy(() => import('./CategoryDelivery/CategoryDelivery')),
	},
	{
		path: '/categorydeliveryregister',
		component: React.lazy(() => import('./CategoryDelivery/CategoryDeliveryRegister')),
	},
	{
		path: '/categorydeliverycsvregister',
		component: React.lazy(() => import('./CategoryDelivery/CategoryDeliveryCsvRegister')),
	},
	{
		path: '/categorydeliveryupdate',
		component: React.lazy(() => import('./CategoryDelivery/CategoryDeliveryUpdate')),
	},
	{
		path: '/categorydeliverydelete',
		component: React.lazy(() => import('./CategoryDelivery/CategoryDeliveryDelete')),
	},

	{
		path: '/toppingdelivery',
		component: React.lazy(() => import('./ToppingDelivery/ToppingDelivery')),
	},
	{
		path: '/toppingdeliveryregister',
		component: React.lazy(() => import('./ToppingDelivery/ToppingDeliveryRegister')),
	},
	{
		path: '/toppingdeliverycsvregister',
		component: React.lazy(() => import('./ToppingDelivery/ToppingDeliveryCsvRegister')),
	},
	{
		path: '/toppingdeliveryupdate',
		component: React.lazy(() => import('./ToppingDelivery/ToppingDeliveryUpdate')),
	},
	{
		path: '/toppingdeliverydelete',
		component: React.lazy(() => import('./ToppingDelivery/ToppingDeliveryDelete')),
	},

	{
		path: '/productdelivery',
		component: React.lazy(() => import('./ProductDelivery/ProductDelivery')),
	},
	{
		path: '/productdeliveryregister',
		component: React.lazy(() => import('./ProductDelivery/ProductDeliveryRegister')),
	},
	{
		path: '/productdeliverycsvregister',
		component: React.lazy(() => import('./ProductDelivery/ProductDeliveryCsvRegister')),
	},
	{
		path: '/productdeliveryupdate',
		component: React.lazy(() => import('./ProductDelivery/ProductDeliveryUpdate')),
	},
	{
		path: '/productdeliverydelete',
		component: React.lazy(() => import('./ProductDelivery/ProductDeliveryDelete')),
	},


	// ================================================================
	// 全店舗共通（storeId = 9999 固定）のテイクアウト商品メンテナンス
	// 店舗未選択（/storehome で選択解除）時のみサイドバーに表示される
	// ================================================================
	{
		path: '/categorytakeoutall',
		component: React.lazy(() => import('./CategoryTakeOutAll/CategoryTakeOutAll')),
	},
	{
		path: '/categorytakeoutallregister',
		component: React.lazy(() => import('./CategoryTakeOutAll/CategoryTakeOutAllRegister')),
	},
	{
		path: '/categorytakeoutallcsvregister',
		component: React.lazy(() => import('./CategoryTakeOutAll/CategoryTakeOutAllCsvRegister')),
	},
	{
		path: '/categorytakeoutallupdate',
		component: React.lazy(() => import('./CategoryTakeOutAll/CategoryTakeOutAllUpdate')),
	},
	{
		path: '/categorytakeoutalldelete',
		component: React.lazy(() => import('./CategoryTakeOutAll/CategoryTakeOutAllDelete')),
	},


	{
		path: '/toppingtakeoutall',
		component: React.lazy(() => import('./ToppingTakeOutAll/ToppingTakeOutAll')),
	},
	{
		path: '/toppingtakeoutallregister',
		component: React.lazy(() => import('./ToppingTakeOutAll/ToppingTakeOutAllRegister')),
	},
	{
		path: '/toppingtakeoutallcsvregister',
		component: React.lazy(() => import('./ToppingTakeOutAll/ToppingTakeOutAllCsvRegister')),
	},
	{
		path: '/toppingtakeoutallupdate',
		component: React.lazy(() => import('./ToppingTakeOutAll/ToppingTakeOutAllUpdate')),
	},
	{
		path: '/toppingtakeoutalldelete',
		component: React.lazy(() => import('./ToppingTakeOutAll/ToppingTakeOutAllDelete')),
	},


	{
		path: '/producttakeoutall',
		component: React.lazy(() => import('./ProductTakeOutAll/ProductTakeOutAll')),
	},
	{
		path: '/producttakeoutallregister',
		component: React.lazy(() => import('./ProductTakeOutAll/ProductTakeOutAllRegister')),
	},
	{
		path: '/producttakeoutallcsvregister',
		component: React.lazy(() => import('./ProductTakeOutAll/ProductTakeOutAllCsvRegister')),
	},
	{
		path: '/producttakeoutallupdate',
		component: React.lazy(() => import('./ProductTakeOutAll/ProductTakeOutAllUpdate')),
	},
	{
		path: '/producttakeoutalldelete',
		component: React.lazy(() => import('./ProductTakeOutAll/ProductTakeOutAllDelete')),
	},


	// ================================================================
	// 全店舗共通（storeId = 9999 固定）のデリバリー商品メンテナンス
	// ================================================================
	{
		path: '/categorydeliveryall',
		component: React.lazy(() => import('./CategoryDeliveryAll/CategoryDeliveryAll')),
	},
	{
		path: '/categorydeliveryallregister',
		component: React.lazy(() => import('./CategoryDeliveryAll/CategoryDeliveryAllRegister')),
	},
	{
		path: '/categorydeliveryallcsvregister',
		component: React.lazy(() => import('./CategoryDeliveryAll/CategoryDeliveryAllCsvRegister')),
	},
	{
		path: '/categorydeliveryallupdate',
		component: React.lazy(() => import('./CategoryDeliveryAll/CategoryDeliveryAllUpdate')),
	},
	{
		path: '/categorydeliveryalldelete',
		component: React.lazy(() => import('./CategoryDeliveryAll/CategoryDeliveryAllDelete')),
	},


	{
		path: '/toppingdeliveryall',
		component: React.lazy(() => import('./ToppingDeliveryAll/ToppingDeliveryAll')),
	},
	{
		path: '/toppingdeliveryallregister',
		component: React.lazy(() => import('./ToppingDeliveryAll/ToppingDeliveryAllRegister')),
	},
	{
		path: '/toppingdeliveryallcsvregister',
		component: React.lazy(() => import('./ToppingDeliveryAll/ToppingDeliveryAllCsvRegister')),
	},
	{
		path: '/toppingdeliveryallupdate',
		component: React.lazy(() => import('./ToppingDeliveryAll/ToppingDeliveryAllUpdate')),
	},
	{
		path: '/toppingdeliveryalldelete',
		component: React.lazy(() => import('./ToppingDeliveryAll/ToppingDeliveryAllDelete')),
	},


	{
		path: '/productdeliveryall',
		component: React.lazy(() => import('./ProductDeliveryAll/ProductDeliveryAll')),
	},
	{
		path: '/productdeliveryallregister',
		component: React.lazy(() => import('./ProductDeliveryAll/ProductDeliveryAllRegister')),
	},
	{
		path: '/productdeliveryallcsvregister',
		component: React.lazy(() => import('./ProductDeliveryAll/ProductDeliveryAllCsvRegister')),
	},
	{
		path: '/productdeliveryallupdate',
		component: React.lazy(() => import('./ProductDeliveryAll/ProductDeliveryAllUpdate')),
	},
	{
		path: '/productdeliveryalldelete',
		component: React.lazy(() => import('./ProductDeliveryAll/ProductDeliveryAllDelete')),
	},


	{
		path: '/CouponCreate',
		component: React.lazy(() => import('./CouponCreate/CouponCreate')),
	},
	{
		path: '/CouponCreateConfirm',
		component: React.lazy(() => import('./CouponCreate/CouponCreateConfirm')),
	},
	{
		path: '/CouponEdit',
		component: React.lazy(() => import('./CouponEdit/CouponEdit')),
	},
	{
		path: '/CouponEditInput',
		component: React.lazy(() => import('./CouponEdit/CouponEditInput')),
	},
	{
		path: '/CouponEditConfirm',
		component: React.lazy(() => import('./CouponEdit/CouponEditConfirm')),
	},
	{
		path: '/CouponEditDelete',
		component: React.lazy(() => import('./CouponEdit/CouponEditDelete')),
	},
	{
		path: '/PushNotificationCreate',
		component: React.lazy(() => import('./PushNotificationCreate/PushNotificationCreate')),
	},
	{
		path: '/PushNotificationConfirm',
		component: React.lazy(() => import('./PushNotificationEdit/PushNotificationConfirm')),
	},
	{
		path: '/PushNotificationEdit',
		component: React.lazy(() => import('./PushNotificationEdit/PushNotificationEdit')),
	},
	{
		path: '/PushNotificationEditInput',
		component: React.lazy(() => import('./PushNotificationEdit/PushNotificationEditInput')),
	},
	{
		path: '/PushNotificationDelete',
		component: React.lazy(() => import('./PushNotificationEdit/PushNotificationDelete')),
	},
	{
		path: '/TableOrder',
		component: React.lazy(() => import('./TableOrder/TableOrder')),
	},
	{
		path: '/TableOrderConfirm',
		component: React.lazy(() => import('./TableOrder/TableOrderConfirm')),
	},
	{
		path: '/TableOrderAddMedia',
		component: React.lazy(() => import('./TableOrder/TableOrderAddMedia')),
	},
	{
		path: '/TableOrderEditMedia',
		component: React.lazy(() => import('./TableOrder/TableOrderEditMedia')),
	},
	{
		path: '/TableOrderDelete',
		component: React.lazy(() => import('./TableOrder/TableOrderDelete')),
	},
	{
		path: '/HiddenMenu',
		component: React.lazy(() => import('./HiddenMenu/HiddenMenu')),
	},
	{
		path: '/HiddenMenuRegister',
		component: React.lazy(() => import('./HiddenMenu/HiddenMenuRegister')),
	},
	{
		path: '/HiddenMenuCsvRegister',
		component: React.lazy(() => import('./HiddenMenu/HiddenMenuCsvRegister')),
	},
	{
		path: '/HiddenMenuUpdate',
		component: React.lazy(() => import('./HiddenMenu/HiddenMenuUpdate')),
	},
	{
		path: '/HiddenMenuDelete',
		component: React.lazy(() => import('./HiddenMenu/HiddenMenuDelete')),
	},


	{
		path: '/PushNotificationAllCreate',
		component: React.lazy(() => import('./PushNotificationAllCreate/PushNotificationAllCreate')),
	},
	{
		path: '/PushNotificationAllConfirm',
		component: React.lazy(() => import('./PushNotificationAllEdit/PushNotificationAllConfirm')),
	},
	{
		path: '/PushNotificationAllEdit',
		component: React.lazy(() => import('./PushNotificationAllEdit/PushNotificationAllEdit')),
	},
	{
		path: '/PushNotificationAllEditInput',
		component: React.lazy(() => import('./PushNotificationAllEdit/PushNotificationAllEditInput')),
	},
	{
		path: '/PushNotificationAllDelete',
		component: React.lazy(() => import('./PushNotificationAllEdit/PushNotificationAllDelete')),
	},

	{
		path: '/CouponAllCreate',
		component: React.lazy(() => import('./CouponAllCreate/CouponAllCreate')),
	},
	{
		path: '/CouponAllCreateConfirm',
		component: React.lazy(() => import('./CouponAllCreate/CouponAllCreateConfirm')),
	},
	{
		path: '/CouponAllEditConfirm',
		component: React.lazy(() => import('./CouponAllEdit/CouponAllEditConfirm')),
	},
	{
		path: '/CouponAllEdit',
		component: React.lazy(() => import('./CouponAllEdit/CouponAllEdit')),
	},
	{
		path: '/CouponAllEditInput',
		component: React.lazy(() => import('./CouponAllEdit/CouponAllEditInput')),
	},
	{
		path: '/CouponAllEditDelete',
		component: React.lazy(() => import('./CouponAllEdit/CouponAllEditDelete')),
	},

	{
		path: '/TableOrderAll',
		component: React.lazy(() => import('./TableOrderAll/TableOrder')),
	},
	{
		path: '/TableOrderAllConfirm',
		component: React.lazy(() => import('./TableOrderAll/TableOrderConfirm')),
	},
	{
		path: '/TableOrderAllAddMedia',
		component: React.lazy(() => import('./TableOrderAll/TableOrderAddMedia')),
	},
	{
		path: '/TableOrderAllEditMedia',
		component: React.lazy(() => import('./TableOrderAll/TableOrderEditMedia')),
	},
	{
		path: '/TableOrderAllDelete',
		component: React.lazy(() => import('./TableOrderAll/TableOrderDelete')),
	},



	{
		path: '/setting',
		component: React.lazy(() => import('./Setting/Setting')),
	},
	{
		path: '/invoicenumber',
		component: React.lazy(() => import('./InvoiceNumber/InvoiceNumber')),
	},
	{
		path: '/discountsetting',
		component: React.lazy(() => import('./DiscountSetting/DiscountSetting')),
	},



	{
		path: '/HomeVideoUrl',
		component: React.lazy(() => import('./HomeVideoUrl/HomeVideoUrl')),
	},
	{
		path: '/HomeVideoAll',
		component: React.lazy(() => import('./HomeVideoAll/HomeVideoAll')),
	},

	{
		path: '/countproduct',
		component: React.lazy(() => import('./CountProduct/CountProduct')),
	},
	{
		path: '/countproductlist',
		component: React.lazy(() => import('./CountProduct/CountProductList')),
	},
	{
		path: '/countproductdelete',
		component: React.lazy(() => import('./CountProduct/CountProductDelete')),
	}
	//{
	//	path: '/forgotpassword',
	//	component: React.lazy(() => import('../../views/sessions/ForgotPassword')),
	//},
];

export default homeRoutes;
